module.exports = __webpack_public_path__ + "static/media/2016.9cb06836.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/about/2016.png
// module id = 607
// module chunks = 0